import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { DrawdownType } from "../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { GadReviewAction } from "./Actions/GadReviewAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { Review } from "./Components/Review/Review";
import { productMap, GadReviewSteppersMap, TextMessages } from "./Resource/Contents";
import { GadReviewInstructionStore } from "./Store/Variable";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { Action } from "../../../Actions/Action";

interface IGadReviewWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
    arrangementId: number;
}
export class GadReviewWizard extends AccountContextWizardComponent<IGadReviewWizardState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(GadReviewInstructionStore, () => this.onInstructionStoreChange());
    }

    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
            arrangementId: Number(getQueryParameters()["arrangementid"]),
        };
    }

    private onInstructionStoreChange() {
        if (GadReviewInstructionStore.getActionType() == ActionType.Success) {
            const data = GadReviewInstructionStore.getData();
            if (data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.InstructionId) {
            }

            this.setState({
                isLoading: false,
                data: data,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        Action.getBankAccounts(hierarchyId, (result) => {
            this.setState({ extraInfo: { AllBankAccounts: result, Drawdowntype: DrawdownType.Capped } }); // To Update the Drawdowntypedetails
        });
    }

    componentDidUpdate(prevProps: any, prevState: IGadReviewWizardState) {
        const { customer, clientAccount, data} = this.state;

        const pensionArrangementId = data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.PensionArrangementId;
        if (!this.state.arrangementId && pensionArrangementId) {
            this.setState({arrangementId: pensionArrangementId});
        }

        if (clientAccount && customer && !this.state.data && (prevState.customer !== customer || prevState.clientAccount !== clientAccount)) {
            const id = getQueryParameters()["id"];
            const npr = clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr);
            if (npr) {
                GadReviewAction.getInstruction(
                    id,
                    clientAccount.HierarchyId,
                    npr.HierarchyId,
                    customer.CustomerId,
                    this.state.arrangementId
                );
            }
        }
    }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {params["id"] = this.state.data.HierarchyId;}
        const { customer } = this.state;
        GadReviewAction.saveInstruction(from, this.state.data, customer?.CustomerId, (result) => {
            this.setState({ onPosting: false });
            if (result?.length > 0) {
                this.setState({
                    errorMsg: result,
                    isShowErrorMsg: true,
                });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        // GadReviewAction.deleteInstruction(this.state.data?.DrawdownIncomeAmendmentInstruction?.Id, () =>
        //     this.onExit()
        // );
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onSubmit() {
        this.setState({ isSubmitting: true });

        GadReviewAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => this.setState({ active: false, isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;

        return stepProps;
    }

    disableWithdraw() {
        const data = RestrictionStore.getData();
        if (RestrictionStore.WithdrawDisabled()) {
            if (getQueryParameters()["id"] > 0) {
                if (
                    this.state.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
                        ?.Income?.GrossIncomePerPayment?.Amount > 0 ||
                    this.state.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
                        ?.Income?.GrossIncomePerPaymentFromPension?.Amount
                ) {
                    return false;
                }
            } else {
                // disableWithdraw
                return true;
            }
        }
        return false;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const { customer, clientAccount } = this.state;

        return [
            {
                title: GadReviewSteppersMap.review,
                url: Urls.get().GadReviewReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                needPrint: true,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[1] && this.child[1].isValid(),
                component: <Review {...this.getStepProps(1)}
                    type={type}
                    arrangementId={this.state.arrangementId}
                />,
            },
            {
                title: GadReviewSteppersMap.comfirm,
                url: Urls.get().GadReviewConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={TextMessages.successMessage(customer?.PersonalDetails?.Name, clientAccount?.HeadClAccountId)}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const disableWithdraw = this.disableWithdraw()

        const steppers = [
            {
                title: GadReviewSteppersMap.incomePaymentDetails,
                url: Urls.get().GadReviewIncomePaymentDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <IncomePaymentDetails
                        readonly={disableWithdraw}
                        isDisableNextBtn={disableWithdraw}
                        {...this.getStepProps(0)}
                        disableWithdraw={disableWithdraw}
                        type={type}
                        extraInfo={this.state.extraInfo}
                        arrangementId={this.state.arrangementId}
                    />
                ),
            },
        ];
        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const { customer, clientAccount } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "GAD review";
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${customer?.PersonalDetails?.Name?.Given} ${customer?.PersonalDetails?.Name?.Family}`,
            splitHeaderSub: clientAccount?.HeadClAccountId,
        };
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
